import { FC } from 'react';
import { AxiosError } from 'axios';
import {
    Buttons,
    StyledReviewChanges,
    StyledTableWrapper
} from "../../CopyOptionRecipe/ReviewChanges/ReviewChanges.styles";
import { H2 } from "../../../../common/Headings/Headings.styles";
import { TableRowWrapper } from "../../../../common/SideBySideTableLayout/SideBySideTableLayout.styles";
import Table from "../../../../components/Table/Table";
import { Variant } from "../../../../components/Button/Button.types";
import Button from "../../../../components/Button/Button";
import { DeleteOptionRecipesStep } from "../DeleteOptionRecipes.types";
import { showToast } from "../../../../components/Toast/Toast";
import { genericErrorShowToastOptions } from "../../../../utils/useGenericErrorMessage/useGenericErrorMessage";
import { ReviewChangesProps } from "./ReviewChanges.types";

const ReviewChanges: FC<ReviewChangesProps> = (
    {
        selectedOptionRecipes,
        setStep,
        mutate,
        isLoading
    }
) => {
    const handleDelete = () => {
        mutate(selectedOptionRecipes, {
            onSuccess: () => {
                setStep(DeleteOptionRecipesStep.Confirmation);
                showToast({
                    label: 'Option recipes were deleted successfully.',
                    id: 'deleteOptionRecipesSuccess'
                });
            },
            onError: (error) => {
                if ((error as AxiosError).message === 'apiGatewayTimeout') return;
                showToast({
                    ...genericErrorShowToastOptions,
                    label: 'Error deleting option recipes.',
                    id: 'deleteOptionRecipesError'
                });
            }
        })
    }
    return (
        <StyledReviewChanges>
            <H2>Review your changes</H2>
            <TableRowWrapper>
                <StyledTableWrapper>
                    <Table
                        rowData={selectedOptionRecipes}
                        headerTitle='Delete Option Recipes'
                        showHeader
                        floatingFiltersHeight={0}
                        returnedRecords={selectedOptionRecipes.length}
                        columnDefs={[
                            {headerName: 'Spec', field: 'specNo', minWidth: 120, maxWidth: 220, flex: 2},
                            {headerName: 'Sub-Spec', field: 'subSpecNo', minWidth: 120, maxWidth: 220, flex: 2},
                            {headerName: 'Class', field: 'classDescription', minWidth: 200, maxWidth: 300, flex: 2},
                            {headerName: 'Base', field: 'baseDescription', minWidth: 200, maxWidth: 300, flex: 2},
                            {headerName: 'Size', field: 'sizeDescription', minWidth: 200, maxWidth: 300, flex: 2},
                            {headerName: 'Product', field: 'productDescription', minWidth: 200, maxWidth: 300, flex: 2},
                            {headerName: 'Option', field: 'optionDescription', minWidth: 200, flex: 2},
                        ]}
                        height={'100%'}
                    />
                </StyledTableWrapper>
            </TableRowWrapper>
            <Buttons>
                <Button label='Back' variant={Variant.Secondary}
                        onClick={() => setStep(DeleteOptionRecipesStep.SelectOptionRecipes)}/>
                <Button label='Delete' onClick={handleDelete} isLoading={isLoading}/>
            </Buttons>
        </StyledReviewChanges>
    );
};

export default ReviewChanges;